import { render, staticRenderFns } from "./Faizler.vue?vue&type=template&id=36d30c86"
import script from "./Faizler.vue?vue&type=script&lang=ts"
export * from "./Faizler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports